import { IUniqCruise } from "@/interfaces/IUniqCruise";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import Image from "next/image";

interface MoreShipModalProps {
  open: boolean;
  close: () => void;
  data: IUniqCruise | null;
}

const MoreShipModal: React.FC<MoreShipModalProps> = ({ open, close, data }) => {
  const smMatches = useMediaQuery("(max-width:600px)");

  return (
    <Dialog open={open} onChange={close} maxWidth="lg" fullWidth={true} fullScreen={smMatches}>
      <DialogTitle>
        <Typography
          // component="span"
          sx={{
            flexShrink: 0,
            fontWeight: 500,
            fontSize: { xs: "1.2rem", md: "1.5rem" },
            textAlign: "left",
            color: "primary.main",
            fontFamily: "'blauerNue', 'blauerNue Fallback'",
          }}
        >
          Your Perfect Cruise Awaits
        </Typography>

        <IconButton
          onClick={close}
          aria-label="Close"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ maxHeight: { xs: "unset", md: "70vh" } }}>
        <div>
          {" "}
          <Grid container spacing={3}>
            {data?.ships.slice(3).map((m, i) => (
              <Grid size={{ xs: 6, sm: 6, md: 3 }} key={i}>
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    height: { xs: "150px", md: "180px" },
                    border: "1px solid  rgba(0, 33, 82, 0.6)",
                    borderColor: "primary.main",
                    boxShadow: "3px 0px 2px rgba(132, 181, 255, 0.3)",
                    borderRadius: "8px",
                    overflow: "hidden",
                    p: "2rem",
                    img: {
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "flex",
                    },
                  }}
                >
                  <Link href={`/best-cruise-ships/${m.id}`} aria-label={`View ${m.name}`}>
                    {m.coverImageHref && (
                      <Image
                        src={m.coverImageHref}
                        fill
                        alt={m.name}
                        loader={({ src }) => src}
                        unoptimized
                        style={{ borderRadius: "8px" }}
                      />
                    )}
                  </Link>
                  <Box
                    sx={{
                      bottom: "1rem",
                      left: 0,
                      position: "absolute",
                      py: "5px",
                      px: "0.5rem",
                      bgcolor: "#ffffff3b",
                      backdropFilter: "blur(5px)",
                      width: "100%",
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: "1rem", md: "1rem" },
                        fontWeight: 400,
                        mx: "8px",
                        color: "#fff",
                        textShadow:
                          "1px 0px 1px black, 0px 1px 1px black, -1px 0px 1px black, 0px -1px 1px black",
                      }}
                    >
                      {m.name}
                    </Typography>{" "}
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MoreShipModal;
